import React from "react";
import { Grid, TextField, InputLabel, Select, MenuItem } from "@mui/material";

interface ClinicInfoEditFormProps {
  clinicForm: {
    id: string;
    BSNR?: string;
    businessName: string;
    phone1: string;
    fax: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    zip: string;
    email: string;
    notes: string;
    methodForDrReport: string;
    methodForRxOrder: string;
  };
  onInputChange: (e: React.ChangeEvent<HTMLElement> | any) => void;
  ReportMethod: any;
}

const ClinicInfoEditForm: React.FC<ClinicInfoEditFormProps> = ({ clinicForm, onInputChange, ReportMethod }) => (
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <TextField
        style={{ marginTop: 0, marginBottom: 0 }}
        label="BSNR"
        name="id"
        value={clinicForm.BSNR ?? clinicForm.id}
        onChange={onInputChange}
        fullWidth
        margin="normal"
        InputProps={{ style: { height: "50px" } }}
      />
    </Grid>
    <Grid item xs={12}>
      <TextField
        style={{ marginTop: 0, marginBottom: 0 }}
        label="Praxisname"
        name="businessName"
        value={clinicForm.businessName || ""}
        onChange={onInputChange}
        fullWidth
        margin="normal"
        InputProps={{ style: { height: "50px" } }}
      />
    </Grid>
    <Grid item xs={12}>
      <TextField
        style={{ marginTop: 0, marginBottom: 0 }}
        label="Telefon"
        name="phone1"
        value={clinicForm.phone1 || ""}
        onChange={onInputChange}
        fullWidth
        margin="normal"
        InputProps={{ style: { height: "50px" } }}
      />
    </Grid>
    <Grid item xs={12}>
      <TextField
        style={{ marginTop: 0, marginBottom: 0 }}
        label="Fax"
        name="fax"
        value={clinicForm.fax || ""}
        onChange={onInputChange}
        fullWidth
        margin="normal"
        InputProps={{ style: { height: "50px" } }}
      />
    </Grid>
    <Grid item xs={12}>
      <TextField
        style={{ marginTop: 0, marginBottom: 0 }}
        label="Address Line 1"
        name="addressLine1"
        value={clinicForm.addressLine1 || ""}
        onChange={onInputChange}
        fullWidth
        margin="normal"
        InputProps={{ style: { height: "50px" } }}
      />
    </Grid>
    <Grid item xs={12}>
      <TextField
        style={{ marginTop: 0, marginBottom: 0 }}
        label="Address Line 2"
        name="addressLine2"
        value={clinicForm.addressLine2 || ""}
        onChange={onInputChange}
        fullWidth
        margin="normal"
        InputProps={{ style: { height: "50px" } }}
      />
    </Grid>
    <Grid item xs={12}>
      <TextField
        style={{ marginTop: 0, marginBottom: 0 }}
        label="City"
        name="city"
        value={clinicForm.city || ""}
        onChange={onInputChange}
        fullWidth
        margin="normal"
        InputProps={{ style: { height: "50px" } }}
      />
    </Grid>
    <Grid item xs={12}>
      <TextField
        style={{ marginTop: 0, marginBottom: 0 }}
        label="Zip"
        name="zip"
        value={clinicForm.zip || ""}
        onChange={onInputChange}
        fullWidth
        margin="normal"
        InputProps={{ style: { height: "50px" } }}
      />
    </Grid>
    <Grid item xs={12}>
      <TextField
        style={{ marginTop: 0, marginBottom: 0 }}
        label="Email"
        name="email"
        value={clinicForm.email || ""}
        onChange={onInputChange}
        fullWidth
        margin="normal"
        InputProps={{ style: { height: "50px" } }}
      />
    </Grid>
    <Grid item xs={12}>
      <TextField
        style={{ marginTop: 0, marginBottom: 0 }}
        label="Hinweise"
        name="notes"
        value={clinicForm.notes || ""}
        onChange={onInputChange}
        fullWidth
        margin="normal"
        InputProps={{ style: { height: "50px" } }}
      />
    </Grid>
    <Grid item xs={12}>
      <InputLabel>Methode für Therapiebericht</InputLabel>
      <Select
        name="methodForDrReport"
        value={clinicForm.methodForDrReport || ReportMethod.Email}
        onChange={onInputChange}
        fullWidth
      >
        {Object.values(ReportMethod).map((method) => (
          <MenuItem key={String(method)} value={method as string}>
            {String(method)}
          </MenuItem>
        ))}
      </Select>
    </Grid>
    <Grid item xs={12}>
      <InputLabel>Methode für Rezeptbestellung</InputLabel>
      <Select
        name="methodForRxOrder"
        value={clinicForm.methodForRxOrder || ReportMethod.Email}
        onChange={onInputChange}
        fullWidth
      >
        {Object.values(ReportMethod).map((method) => (
          <MenuItem key={String(method)} value={method as string}>
            {String(method)}
          </MenuItem>
        ))}
      </Select>
    </Grid>
  </Grid>
);

export default ClinicInfoEditForm;
